import CollateralChart from "./CollateralChart";
export default CollateralChart;
